import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import {
  act_GetDivision,
  act_GetLocation_Division,
  actGetPrimaryNode,
} from '../../actions/EEReportAction';
import { hide, show } from '../../actions/ActivityIndicatorAction';
import Auth from '../../shared/Auth';
import { parseQueryString } from '../../utils/helper';
import {
  getCircleByUser,
  getDivisionByCircleId,
  session,
} from '../../Service/APIService';
import Axios from '../../utils/axiosClient';

class DivLocAsset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      circle: [],
      divisions: [],
      feeders: [],
      location: [],
      products: [],
      show: {
        feeder: props.isFeeder,
        location: props.isLocation,
      },
      defSelectedlocation: 0,
      isDefaultSelected: false,
      ddlOptions: {
        reportlevel: '',
        circle: {
          selected: '',
          isdisabled: false,
        },
        division: {
          selected: '',
          isdisabled: false,
        },
        location: {
          selected: '',
          isdisabled: false,
        },
        feeder: {
          selected: '',
          isdisabled: false,
        },
      },
    };
  }

  async UNSAFE_componentWillMount() {
    const circleFromApi = await this.loadCircle();
    const cirVal = circleFromApi.length > 0 ? circleFromApi[0].value : 0;

    this.loadFirstValuesForAllDropDowns(cirVal);
    this.setState({
      ...this.state,
      circle: [].concat(circleFromApi),
    });
  }

  async loadFirstValuesForAllDropDowns(cirVal) {
    // added for #1263
    const checkToken = await Auth();
    let divVal = '';
    let locVal = '';
    let feedVal = '';
    let cirDisable = true;
    let divDisable = true;
    let locDisable = true;
    let feedDisable = true;
    if (checkToken) {
      let urlParameters = '';
      const urlEncoded = window.location.search;
      if (urlEncoded !== '') {
        const decodedText = atob(window.location.search.split('?')[1]);
        urlParameters = await parseQueryString(decodedText);
      }
      const paraLength = Object.keys(urlParameters).length;
      // this.props.show();
      const userInfo = session.user();
      // Fetch Divisions from API
      const divisionsFromApi = await this.loadDivision(cirVal);
      // added by nilesh for default selection on SLD click
      divVal =
        paraLength > 0
          ? urlParameters.divId
          : divisionsFromApi.length > 0 && divisionsFromApi[0].value;
      // divVal = divisionsFromApi.length > 0 && divisionsFromApi[0].value;

      // Fetch Locations from API from first division value from above
      const locationFromApi = await this.loadLocations(divVal);
      // added by nilesh for default selection on SLD click
      locVal =
        paraLength > 0
          ? urlParameters.asptId
          : locationFromApi.length > 0 && locationFromApi[0].value;

      // locVal = locationFromApi.length > 0 && locationFromApi[0].value;

      // Fetch Locations from API from first Location value from above
      const feedersFromApi = []; // await this.loadAsset(locVal);

      // Enable Division, then auto select first dropdown value ignoring (-- select --)
      // const txtDiv = document.getElementById('txtDivision');
      // const txtLoc = document.getElementById('cmbLocation');
      // const txtFeed = document.getElementById('cmbFeeder');
      const txtLvl = document.getElementById('cmbLevel');
      // added by nilesh for default selection on SLD click - START

      let paraToPass = '';
      cirDisable = false;
      if (paraLength > 0) {
        divDisable = false;
        locDisable = false;
        feedDisable = false;

        // txtDiv.value = divVal;
        // txtLoc.value = locVal;
        if (urlParameters.asstId === undefined) {
          // txtFeed.value = '';
          feedDisable = true;
        } else {
          feedVal = urlParameters.asstId;
        }

        paraToPass = 'Feeder';
        if (this.props.isReportLevel) {
          txtLvl.options[paraLength].setAttribute('selected', 'selected');
        }
      } else {
        // - END
        divVal = divisionsFromApi[0].value;
        // txtDiv.options[1].setAttribute('selected', 'selected');

        if (
          (userInfo.roleId === 1 ||
            userInfo.roleId === 2 ||
            userInfo.roleId === 4) &&
          !this.props.isAssetReport
        ) {
          // Set report level to Division by default
          if (this.props.isReportLevel) {
            txtLvl.options[1].setAttribute('selected', 'selected');
          }
          paraToPass = 'Division';
          locVal = '';
        } else if (userInfo.roleId === 3 && !this.props.isAssetReport) {
          // Enable Division and Location auto, then select first dropdown value ignoring (-- select --)
          // txtLoc.disabled = false;
          locDisable = false;
          locVal = locationFromApi[0].value;
          // txtLoc.options[1].setAttribute('selected', 'selected');
          if (!this.props.isSLDViewer) {
            if (this.props.isReportLevel) {
              txtLvl.options[2].setAttribute('selected', 'selected'); // Set report level to Substation by default
            }
          }
          paraToPass = 'Location';
        } else {
          // Enable Division and Location auto, then select first dropdown value ignoring (-- select --)
          // txtLoc.disabled = false;
          // txtFeed.disabled = false;
          locDisable = false;
          feedDisable = false;
          locVal = locationFromApi[0].value;
          feedVal = feedersFromApi.length && feedersFromApi[0].value;
          // txtLoc.options[1].setAttribute('selected', 'selected');
          // txtFeed.options[1].setAttribute('selected', 'selected');
          if (this.props.isReportLevel) {
            txtLvl.options[3].setAttribute('selected', 'selected');
          }
          if (!this.props.isFeeder) {
            paraToPass = 'Location';
          } else {
            paraToPass = 'Feeder';
          }
        }
        // this.props.hide();
      }
      this.setState(
        {
          divisions: [].concat(divisionsFromApi),
          location: [].concat(locationFromApi),
          feeders: [].concat(feedersFromApi),
          ddlOptions: {
            circle: {
              selected: cirVal,
              isdisabled: cirDisable,
            },
            division: {
              selected: divVal,
              isdisabled: divDisable,
            },
            location: {
              selected: locVal,
              isdisabled: locDisable,
            },
            feeder: {
              selected: feedVal,
              isdisabled: feedDisable,
            },
          },
        },
        () => this.passParamer(paraToPass)
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultSelected.division !== 0 &&
      nextProps.isDefaultSelected
    ) {
      if (
        this.props.defaultSelected.location !==
          nextProps.defaultSelected.location ||
        this.props.isDefaultSelected !== nextProps.isDefaultSelected
      ) {
        this.setState({
          defSelectedlocation: nextProps.defaultSelected.location,
          isDefaultSelected: nextProps.isDefaultSelected,
          ddlOptions: {
            ...this.state.ddlOptions,
            division: { select: nextProps.defaultSelected.division },
          },
        });
        this.bindLocationByDivision(nextProps.defaultSelected.division);
      }
    } else {
      this.setState({
        defSelectedlocation: '',
        isDefaultSelected: nextProps.isDefaultSelected,
      });
    }
  }
  async loadCircle() {
    let Data = [];
    const sessionId = session.client();
    await getCircleByUser(sessionId)
      .then((res) => {
        if (res.data.result) {
          Data = res.data.result.map((div) => ({
            value: div.circleId.toString(),
            display: div.circleName,
            original: div,
          }));
          Data = [...new Map(Data.map((item) => [item.value, item])).values()];
        }
      })
      .catch((err) => {
        console.log(err);
      });
    return Data;
  }
  // loads divisons
  async loadDivision(crid) {
    const dv = await getDivisionByCircleId(crid);
    let res = dv.data.result.map((div) => ({
      value: div.divisionId.toString(),
      display: div.divName,
      original: div,
    }));
    res = [...new Map(res.map((item) => [item.value, item])).values()];
    return res;
  }

  async loadLocations(divisionId) {
    let Data = [];
    const userInfo = session.user();
    const sessionId = session.client();
    await this.props
      .act_GetLocation_Division(divisionId, userInfo.memberId, sessionId)
      .then(
        (res) => {
          if (res.payload.data.statusCode === 200) {
            Data = res.payload.data.result.map((div) => ({
              value: div.AssetPointId.toString(),
              display: div.AssetPointName,
              original: div,
            }));
          }
        },
        (err) => {
          console.log(err);
        }
      );
    return Data;
  }

  async loadAsset(locationId) {
    let Data = [];
    const url = `appsconfig/assetsbyappIdastptid/${locationId}/${this.props.appId}`;
    await Axios.get(url).then(
      (res) => {
        if (res.data.statusCode === 200) {
          Data = res.data.result.map((div) => ({
            value: div.assetId,
            display: div.assetName,
          }));
        }
      },
      (err) => {
        console.log(err);
      }
    );
    return Data;
  }
  async bindDivisionByCircle(value) {
    const current = this;
    current.setState({
      ...this.state,
      divisions: [{ value: '', display: '-- Select --' }],
      location: [{ value: '', display: '-- Select --' }],
      ddlOptions: {
        ...this.state.ddlOptions,
        division: {
          selected: '',
          isdisabled: false,
        },
        location: {
          selected: '',
          isdisabled: false,
        },
      },
    });
    current.passParamer('Circle');

    this.props.show();
    const checkToken = await Auth();
    if (checkToken) {
      const divisionFromApi = await this.loadDivision(value);
      current.setState({
        divisions: [
          { value: '', display: '-- Select --', original: {} },
        ].concat(divisionFromApi),
        location: [{ value: '', display: '-- Select --' }],
        ddlOptions: { ...this.state.ddlOptions, circle: { selected: value } },
      });
      if (current.state.isDefaultSelected) {
        this.setState({
          ddlOptions: {
            ...this.state.ddlOptions,
            division: { selected: this.state.defSelecteddivision },
          },
        });
        current.passParamer('Division');
      } else {
        current.passParamer('Circle');
      }
    }
    this.props.hide();
  }

  async bindLocationByDivision(value) {
    const current = this;
    current.setState({
      ...this.state,
      location: [{ value: '', display: '-- Select --' }],
      ddlOptions: {
        ...this.state.ddlOptions,
        location: {
          selected: '',
          isdisabled: false,
        },
      },
    });
    current.passParamer('Division');

    this.props.show();
    const checkToken = await Auth();
    if (checkToken) {
      const locationFromApi = await this.loadLocations(value); // fetch location data
      current.setState({
        location: [{ value: '', display: '-- Select --', original: {} }].concat(
          locationFromApi
        ),
        feeders: [{ value: '', display: '-- Select --' }],
        ddlOptions: { ...this.state.ddlOptions, division: { selected: value } },
      });
      if (current.state.isDefaultSelected) {
        this.setState({
          ddlOptions: {
            ...this.state.ddlOptions,
            location: { selected: this.state.defSelectedlocation },
          },
        });
        current.passParamer('Location');
      } else {
        current.passParamer('Division');
      }
    }
    this.props.hide();
  }

  async bindAssetsByLocation(locationId) {
    this.setState(
      {
        ddlOptions: {
          ...this.state.ddlOptions,
          location: { selected: locationId },
        },
      },
      async () => {
        const current = this;
        if (locationId === '') {
          this.setState({
            feeders: [{ value: '', display: '-- Select --' }],
          });
          current.passParamer('Location'); // added by nilesh as nothing was happened when we select on "please select"
          return;
        }
        this.props.show();
        const checkToken = await Auth();
        if (checkToken) {
          const feedersFromApi = []; //await this.loadAsset(locationId);
          current.setState({
            feeders: [{ value: '', display: '-- Select --' }].concat(
              feedersFromApi
            ),
          });
        }
        this.props.hide();
        this.passParamer('Location');
      }
    );
  }

  bindCharts(selectedFeeder) {
    this.setState(
      {
        ddlOptions: {
          ...this.state.ddlOptions,
          feeder: { selected: selectedFeeder },
        },
      },
      () => this.passParamer('Feeder')
    );
  }

  // passParamer(changeType) {
  //     const obj = {
  //         type: changeType,
  //         division: document.getElementById('txtDivision').value,
  //         location: document.getElementById('cmbLocation').value,
  //         feeder: document.getElementById('cmbFeeder')===null ? 0 : document.getElementById('cmbFeeder').value,
  //         locObj: this.state.location.filter(x => x.value === document.getElementById('cmbLocation').value)[0].original,
  //         divObj: this.state.divisions.filter(x => x.value === document.getElementById('txtDivision').value)[0].original,
  //     };

  //     this.props.onChange(obj);
  // }

  passParamer(changeType) {
    const {
      state: {
        ddlOptions: {
          circle: { selected: selectedCir },
          division: { selected: selectedDiv },
          location: { selected: selectedLoc },
          feeder: { selected: selectedFeeder },
        },
        divisions,
        location,
      },
    } = this;

    const obj = {
      type: changeType,
      circle: selectedCir,
      division: selectedDiv, // document.getElementById('txtDivision').value,
      location: selectedLoc,
      feeder: selectedFeeder,
      locObj:
        location.filter((x) => x.value === selectedLoc?.toString())[0]
          ?.original || [],
      divObj:
        divisions.filter((x) => x.value === selectedDiv?.toString())[0]
          ?.original || [],
    };

    this.props.onChange(obj);
  }

  makeDisable(event) {
    const {
      ddlOptions: {
        circle: { selected: selectedCir },
        division: { selected: selectedDiv },
        location: { selected: selectedLoc },
      },
    } = this.state;

    // ddlDivision.disabled = false;
    // ddlLocation.disabled = false;
    // ddlAsset.disabled = false;
    let cirVal = selectedCir;
    let divVal = selectedDiv;
    let locVal = selectedLoc;
    let feedVal = '';
    let cirDisable = false;
    let divDisable = false;
    let locDisable = false;
    let feedDisable = false;

    switch (event.target.value) {
      case 'Circle':
        if (cirVal !== '') {
          this.bindDivisionByCircle(cirVal);
        }
        divVal = '';
        divDisable = true;

        locDisable = true;
        feedDisable = true;
        break;
      case 'Division':
        if (divVal !== '') {
          this.bindLocationByDivision(divVal);
        }
        locVal = '';
        locDisable = true;
        feedDisable = true;
        break;
      case 'Substation':
        if (locVal !== '') {
          this.bindAssetsByLocation(locVal);
        }
        feedVal = '';
        feedDisable = true;
        break;
      case '':
        cirVal = '';
        cirDisable = true;
        divVal = '';
        divDisable = true;
        locVal = ''; // #1263
        locDisable = true;
        feedVal = ''; // #1263
        feedDisable = true;
        break;
      default:
        break;
    }

    this.setState({
      ddlOptions: {
        circle: {
          selected: cirVal,
          isdisabled: cirDisable,
        },
        division: {
          selected: divVal,
          isdisabled: divDisable,
        },
        location: {
          selected: locVal,
          isdisabled: locDisable,
        },
        feeder: {
          selected: feedVal,
          isdisabled: feedDisable,
        },
      },
    });
    if (event.target.value === '') {
      this.passParamer('');
    }
  }

  render() {
    const { dvSize, isReportLevel, cirName, divName, locName } = this.props;
    const {
      circle,
      divisions,
      location,
      feeders,
      ddlOptions: {
        circle: { selected: cirSelected, isdisabled: cirDisabled },
        division: { selected: divSelected, isdisabled: divDisabled },
        location: { selected: locSelected, isdisabled: locDisabled },
        feeder: { selected: feedSelected, isdisabled: feedDisable },
      },
    } = this.state;
    const firstNodeOptions = circle.map((circle) => ({
      value: circle.value,
      label: circle.display,
    }));
    const secondNodeOptions = divisions.map((division) => ({
      value: division.value,
      label: division.display,
    }));
    const thirdNodeOptions = location.map((_location) => ({
      value: _location.value,
      label: _location.display,
    }));
    const fourthNodeOptions = feeders.map((feeder) => ({
      value: feeder.value,
      label: feeder.display,
    }));
    const selectedLoc = location.find(
      (x) => x.value.toString() === locSelected?.toString()
    );
    const selectedCir = circle.find(
      (x) => x.value.toString() === cirSelected?.toString()
    );
    const selectedDiv = divisions.find(
      (x) => x.value.toString() === divSelected?.toString()
    );
    const selectedFeeder = feeders.find(
      (x) => x.value.toString() === feedSelected?.toString()
    );
    const tmpcirDisabled = isReportLevel ? cirDisabled : isReportLevel;
    const tmpdivDisabled = isReportLevel ? divDisabled : isReportLevel;
    const tmplocDisabled = isReportLevel ? locDisabled : isReportLevel;
    const tmpfeedDisabled = isReportLevel ? feedDisable : isReportLevel;
    return (
      <div className="col-sm-12" style={{ marginTop: '6px' }}>
        <div className="form-group">
          {isReportLevel && (
            <Col md={dvSize}>
              <label htmlFor="inputEmail3" className="control-label">
                Report Level
              </label>
              <select
                className="form-control"
                id="cmbLevel"
                placeholder=""
                onChange={this.makeDisable.bind(this)}
              >
                <option value="">-- Select Report Level --</option>
                <option value="Circle">Circle</option>
                <option value="Division">Division</option>
                <option value="Substation">Location</option>
                <option value="Feeder">Asset</option>
              </select>
            </Col>
          )}

          <Col md={dvSize}>
            <label htmlFor="inputEmail3" className="control-label">
              {cirName}
            </label>
            <Select
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              menuPortalTarget={document.body}
              options={firstNodeOptions}
              id="cmbCircle"
              isDisabled={tmpcirDisabled}
              value={
                selectedCir && {
                  value: selectedCir.value,
                  label: selectedCir.display,
                }
              }
              onChange={(selectedOption) =>
                this.bindDivisionByCircle(selectedOption.value)
              }
            />
          </Col>
          <Col md={dvSize}>
            <label htmlFor="inputEmail3" className="control-label">
              {divName}
            </label>
            <Select
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              menuPortalTarget={document.body}
              options={secondNodeOptions}
              id="txtDivision"
              isDisabled={tmpdivDisabled}
              value={
                selectedDiv && {
                  value: selectedDiv.value,
                  label: selectedDiv.display,
                }
              }
              onChange={(selectedOption) =>
                this.bindLocationByDivision(selectedOption.value)
              }
            />
          </Col>
          <Col md={dvSize}>
            <label htmlFor="inputEmail3" className="control-label">
              {locName}
            </label>
            <Select
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              menuPortalTarget={document.body}
              options={thirdNodeOptions}
              id="cmbLocation"
              isDisabled={tmplocDisabled}
              value={
                selectedLoc && {
                  value: selectedLoc.value,
                  label: selectedLoc.display,
                }
              }
              onChange={(selectedOption) =>
                this.bindAssetsByLocation(selectedOption.value)
              }
            />
          </Col>
          {this.state.show.feeder && (
            <Col md={dvSize}>
              <label htmlFor="inputEmail3" className="control-label">
                Asset
              </label>
              <Select
                options={fourthNodeOptions}
                id="cmbFeeder"
                isDisabled={tmpfeedDisabled}
                value={
                  selectedFeeder && {
                    value: selectedFeeder.value,
                    label: selectedFeeder.display,
                  }
                }
                onChange={(selectedOption) =>
                  this.bindCharts(selectedOption.value)
                }
              />
            </Col>
          )}
        </div>
      </div>
    );
  }
}

DivLocAsset.propTypes = {
  isFeeder: PropTypes.bool,
  isLocation: PropTypes.bool,
  isReportLevel: PropTypes.bool,
  dvSize: PropTypes.number,
  defaultDDL: PropTypes.object,
  act_GetDivision: PropTypes.func,
  act_GetLocation_Division: PropTypes.func,
  act_GetFeeders_By_Assetpoint: PropTypes.func,
  onChange: PropTypes.func,
  hide: PropTypes.func,
  show: PropTypes.func,
  divName: PropTypes.string,
  locName: PropTypes.string,
};

DivLocAsset.defaultProps = {
  isFeeder: true,
  isLocation: true,
  isReportLevel: true,
  dvSize: 3,
  defaultSelected: {
    division: 0,
    location: 0,
  },
  cirName: 'Circle',
  divName: 'Division',
  locName: 'Location',
  isDefaultSelected: false,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      act_GetDivision,
      act_GetLocation_Division,
      show,
      hide,
      actGetPrimaryNode,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(DivLocAsset);
